export const config = {
    API_URL:'https://backend.beta-staging.tripex.ai/admin-service/api/v1'
}
